import Usuario from './Usuario'
import Orgao from './Orgao'

class Agente {
    constructor(
        {

            id = null,
            codigo_agente = null,
            matricula = null,
            nome = null,
            apelido = null,
            orgao_id = null,  
            ind_ativo = true,
            ind_uso_app = false,
            ind_uso_bhpro = true,
            senha_app  = null,           
            created_at = null,
            updated_at = null,
            deleted_at = null,
            usuario_id = null,

            //ORM
            orgao = {},
            usuario = {},
        } = {}
    ) {
        this.id = id;
        this.codigo_agente = codigo_agente,
        this.matricula = matricula,
        this.nome = nome,
        this.apelido = apelido;
        this.ind_ativo = ind_ativo;
        this.orgao_id = orgao_id;  
        this.ind_uso_app = ind_uso_app;
        this.ind_uso_bhpro = ind_uso_bhpro;
        this.senha_app = senha_app;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;        
        this.usuario_id = usuario_id;
        //ORM
        this.usuario = usuario ? new Usuario(usuario) : new Usuario();
        this.orgao = new Orgao(orgao);
    }


    isMunicipal(){   return this.orgao.poder== "M"    }
    isFederal(){   return this.orgao.poder== "F"    }
    isEstadual(){   return this.orgao.poder== "E"    }


}

export default Agente;